export var showOnSplit = function (showOnValue) {
    return showOnValue === null || showOnValue === void 0 ? void 0 : showOnValue.split(" ").map(function (word) { return "showOn".concat(word.charAt(0).toUpperCase() + word.slice(1)); }).join(" ");
};
export var generateGridTemplateColumns = function (grid) {
    return grid.map(function (value) { return "minmax(0, ".concat(value, "fr)"); }).join(' ');
};
